import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-268d3792")

_pushScopeId("data-v-268d3792")
const _hoisted_1 = { class: "responsive-chart-container" }
const _hoisted_2 = {
  key: 0,
  class: "responsive-chart-width"
}
const _hoisted_3 = {
  key: 1,
  class: "responsive-chart-width"
}
const _hoisted_4 = { class: "responsive-detail" }
const _hoisted_5 = {
  key: 0,
  class: "col-span-4 px-3 text-12px font-medium text-gray-lp-800"
}
const _hoisted_6 = { class: "font-bold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_DonutChart = _resolveComponent("DonutChart")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_DetailStatusCardDashboardClient = _resolveComponent("DetailStatusCardDashboardClient")!
  const _component_CardDashboardClient = _resolveComponent("CardDashboardClient")!

  return (_openBlock(), _createBlock(_component_CardDashboardClient, {
    title: _ctx.$t('dashboard.detail'),
    tooltipTitle: _ctx.$t('dashboard.tooltipClaimData')
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode(_component_Skeleton, { height: "75%" })
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_DonutChart, {
                chartSeries: _ctx.chartData,
                chartColor: _ctx.chartColor,
                chartHeight: _ctx.chartHeight,
                isShowTotal: "",
                fontSizeValue: "16px",
                fontSizeName: "10px",
                chartTitle: _ctx.$t('dashboard.totalClaim'),
                class: _ctx.ableToViewDetail ? 'container-chart' : '',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickDetail('claim-total')))
              }, null, 8, ["chartSeries", "chartColor", "chartHeight", "chartTitle", "class"])
            ])),
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.claimPerStatus, (claim, index) => {
            return (_openBlock(), _createBlock(_component_DetailStatusCardDashboardClient, {
              class: ["responsive-width-detail", `${index > 0 && 'border-l'}`],
              key: claim,
              title: claim.title,
              loading: _ctx.isLoading,
              value: claim.value,
              color: claim.color,
              ableToClick: claim.ableToClick,
              onClick: ($event: any) => (_ctx.onClickDetail(`claim-${claim.type}`))
            }, {
              default: _withId(() => [
                _createVNode(_component_ProgressBar, {
                  value: _ctx.valueProgressBar(claim.value, _ctx.totalClaim),
                  class: "w-full mr-2",
                  startValue: 0,
                  endValue: _ctx.totalClaim,
                  customColor: claim.color
                }, null, 8, ["value", "endValue", "customColor"])
              ]),
              _: 2
            }, 1032, ["class", "title", "loading", "value", "color", "ableToClick", "onClick"]))
          }), 128)),
          (!_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createTextVNode(" *" + _toDisplayString(_ctx.$t("dashboard.claimMbgSuccess")) + " ", 1),
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.formattedClaimMbg), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "tooltipTitle"]))
})